export default __webpack_public_path__ + "static/media/slider-typography-02.d234c576.png";